import { prepareNotificationText } from '@molecules/NotificationText/prepareNotificationText';
import { getSystemLinkContext } from '@molecules/SystemLink/systemLinkContext';
import { ISystemLinkContext, SystemLinkKind, trimBasePath } from '@/utils/resolveSystemLink';

/**
 * Первая ссылка вида `kind` (страница этой системы) из текста уведомления — путём приложения для перехода в этой
 * вкладке; такой нет — `null`.
 */
export const notificationTextLink = (
    text: string | null | undefined,
    kind: SystemLinkKind,
    context: ISystemLinkContext = getSystemLinkContext(),
): string | null => {
    if (!text) return null;
    const link = prepareNotificationText(text, context).links.find((item) => item.kind === kind);
    if (!link) return null;
    const url = new URL(link.href);
    const basePath = trimBasePath(context.basePath);
    const path =
        basePath && url.pathname.startsWith(`${basePath}/`) ? url.pathname.slice(basePath.length) : url.pathname;
    return `${path}${url.search}${url.hash}`;
};
